import React, { useMemo, useState } from 'react'
import useQueryGetMe from '@/api/auth/getMe.ts'
import Menu, { WMOption } from '@/component/menu/Menu.tsx'
import { useAuth } from '@/hooks/useAuth'
import { toast } from 'react-toastify'
import { useNavigate, Link } from 'react-router-dom'
import CarearlyLogo from '@/assets/ic_huggy_logo.svg?react'
import SolidButton from '@/component/button/SolidButton.tsx'
import Hamburger from '@/assets/ic_hambuger.svg?react'
import TopNavMobileButton from '@/component/layout/TopNav/TopNavMobileButton.tsx'
import DotDotDot from '@/assets/ic_dotdotdot.svg?react'
import { useTranslation } from 'react-i18next'
import LanguageIcon from '@/assets/img_language.svg?react'
import TagP from '@/component/text/TagP.tsx'

type IProps = {
    className?: string;
    type?: TYPE_TopNav
}


export enum TYPE_TopNav {
    DEFAULT,
    GUIDE,
}

const TopNav: React.FunctionComponent<IProps> = ({ className, type = TYPE_TopNav.DEFAULT }) => {
    // TopNav는 항상 렌더링되므로, 로그인된 상태에서만 API 호출하도록 제어
    const { logout, isLoggedIn } = useAuth()
    const { data: me } = useQueryGetMe()

    const { t, i18n } = useTranslation()
    const navigate = useNavigate()
    const [showMobileMenu, setShowMobileMenu] = useState(false)

    const menuItems: WMOption[] = useMemo(() => {
        const list: WMOption[] = []

        list.push({
            id: 'account',
            text: t('topNav.menu.account'),
            onClick: () => {
                navigate('/account')
            }
        })

        list.push({
            id: 'logout',
            text: t('topNav.menu.logout'),
            onClick: () => {
                logout()
                toast.success(t('topNav.menu.logout.success'))
                navigate('/login')
            }
        })

        return list
    }, [t])

    // 언어 변경하기
    const changeLanguage = (lang: string) => {
        i18n.changeLanguage(lang)
    }

    const languageItems: WMOption[] = useMemo(() => {
        const list: WMOption[] = []

        list.push({
            id: 'ko',
            text: t('V3.language.ko'),
            onClick: () => {
                changeLanguage('ko')
            }
        })
        list.push({
            id: 'en',
            text: t('V3.language.en'),
            onClick: () => {
                changeLanguage('en')
            }
        })
        list.push({
            id: 'ja',
            text: t('V3.language.ja'),
            onClick: () => {
                changeLanguage('ja')
            }
        })
        list.push({
            id: 'cn',
            text: t('V3.language.cn'),
            onClick: () => {
                changeLanguage('cn')
            }
        })

        return list
    }, [])

    return <>
        <div className={'relative'}>
            <div
                className={`${className} w-full min-h-[80px] md:min-h-[50px] bg-white flex items-center px-[34px] md:px-[15px] border-b border-solid border-gray2 md:py-[10.5px] gap-[41px]`}>
                <Link to={'/'}>
                    <CarearlyLogo className={'w-[151px] md:w-[115px] md:h-[28px]'} />
                </Link>
                <div className={'grow flex gap-[10px]'}>
                    {type == TYPE_TopNav.GUIDE &&
                        <button className={'text-body md:hidden'}
                            onClick={() => navigate('/guide')}>{t('topNav.manual')}</button>}
                </div>
                <div className={'flex items-center gap-[10px]'}>
                    {type == TYPE_TopNav.DEFAULT && isLoggedIn && <Menu
                        items={menuItems}
                        render={<div className={'flex gap-[10px]'}>
                            <div className={'text-[14px] py-[5px] px-[10px] bg-sub_b'}>
                                <TagP>{t('topNav.sayHello', { name: me?.name })}</TagP>
                            </div>
                            <DotDotDot />
                        </div>} />}
                    {type == TYPE_TopNav.GUIDE &&
                        <SolidButton text={t('topNav.guide.service')}
                            className={'rounded-[10px] min-h-[43px] md:hidden min-w-[160px]'}
                            size={'small'} onClick={() => {
                                if (isLoggedIn) {
                                    navigate('/dashboard')
                                } else {
                                    navigate('/login')
                                }
                            }} />}
                    <Menu items={languageItems} render={<div className={'flex gap-[10px]'}>
                        <div
                            className={'text-[14px] select-none bg-gray-500 text-white rounded-full min-w-[40px] min-h-[40px] flex items-center justify-center'}>
                            <LanguageIcon className={'fill-white p-[9px]'} />
                        </div>
                    </div>}>
                    </Menu>
                    {type == TYPE_TopNav.GUIDE && <div className={'hidden md:block'}>
                        <button onClick={() => setShowMobileMenu(!showMobileMenu)}>
                            <Hamburger />
                        </button>
                    </div>}
                </div>
            </div>
        </div>
        {type == TYPE_TopNav.GUIDE && showMobileMenu &&
            <div className={'hidden md:grid w-full absolute top-[50px] shadow z-modal'}>
                <TopNavMobileButton text={t('topNav.guide.service')} onClick={() => {
                    if (isLoggedIn) {
                        navigate('/dashboard')
                    } else {
                        navigate('/login')
                    }
                }} />
                <TopNavMobileButton text={t('topNav.guide.manual')} onClick={() => {
                    navigate('/guide')
                }} />
            </div>}
    </>
}

export default TopNav
